module.exports = __webpack_public_path__ + "img/邻云.38cabd92.jpg";